import { type SubscriptionInfo, type User } from "lens-platform-sdk";
import { RecurlyPlanCode, trialPlanCodes } from "./recurly";

export const isTrialUsed = (
  subscriptions: SubscriptionInfo[]
) => {
  if (!subscriptions) {
    return false;
  }

  return subscriptions.some(
    (subscriptions) => trialPlanCodes.includes(subscriptions.planCode as RecurlyPlanCode)
  );
};

export const getUserAvatar = (user: User) => user.userAttributes?.find((attribute) => attribute.name === "avatar")?.value;
